import React, { useEffect, useState } from 'react'
import { parseISO, addHours } from 'date-fns'
import { format } from 'date-fns-tz'

import api from '../service/api'

import Navbar from '../components/navbar'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarCheck, faMapMarkedAlt, faUsers } from '@fortawesome/free-solid-svg-icons'

export default function Eventos() {

    const [eventos, setEventos] = useState([])

    useEffect(() => {
        async function loadEventos() {
            const response = await api.get('/open/eventos?sort=-data')
            setEventos(response.data)
        }

        loadEventos()
    }, [])

    function formatData(data) {
        const parsedDate = parseISO(data)
        const addedDate = addHours(parsedDate, 3)
        return format(addedDate, 'dd/MM/yyyy', {
            timeZone: 'America/Sao_Paulo',
        })
    }

    function showPalestrantes(palestrantes) {
        if (palestrantes.length === 0)
            return 'Palestrantes não informados'

        let texto = ''

        palestrantes.length > 1
            ? texto = 'Palestrantes: '
            : texto = 'Palestrante: '

        palestrantes.map(palestrante => (
            texto += palestrante.nome + ` (${palestrante.curriculo}), `
        ))

        return texto.substring(0, texto.length - 2)
    }

    return (
        <div id="eventos h-100">

            <Navbar bgColor='rgba(68, 1, 91)' />

            <div id="noticas-content" className="my-5 py-5" style={{ backgroundColor: "#eee" }}>

                {eventos.length > 0
                    ? eventos.map(evento => (
                        <div key={evento._id} className="card mb-3 w-75 mx-auto my-4">
                            <div className="row no-gutters">
                                <div className="col-md-4">
                                    <img src={api.defaults.baseURL + evento.fotoUrl} className="card-img" alt="capa" />
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4"> {evento.nome}</h5>

                                        <div className="m-0 p-0">
                                            <p id="data" className="card-text">
                                                <FontAwesomeIcon icon={faCalendarCheck} style={{ color: "rgb(68, 1, 91)" }} /> {formatData(evento.data)}
                                            </p>

                                            <p id="local" className="card-text">
                                                <FontAwesomeIcon icon={faMapMarkedAlt} style={{ color: "rgb(68, 1, 91)" }} /> {evento.local}
                                            </p>

                                            <p id="palestrantes" className="card-text">
                                                <FontAwesomeIcon icon={faUsers} style={{ color: "rgb(68, 1, 91)" }} /> {showPalestrantes(evento.palestrantes)}
                                            </p>
                                        </div>

                                        <p id="descricao" className="card-text mt-4"> {evento.descricao} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    : <p className="text-center">Não há eventos cadastrados.</p>
                }
            </div>
        </div>
    )
}